export const isDev = import.meta.env.MODE == "development";
export function requireImage(url) {
  return new URL(url, import.meta.url).href;
}

export function showError(message) {
  // setTimeout是防止showLoading导致showToast不显示
  setTimeout(() => {
    uni.showToast({
      title: message || "网络错误，请稍后再试",
      icon: "none",
      duration: 2000,
    });
  }, 0);
}

export function toastSuccess(msg = "") {
  uni.showToast({
    title: msg,
    icon: "success",
  });
}

export function msgSuccess(msg = "") {
  uni.showToast({
    title: msg,
  });
}

export function msgError(msg = "") {
  uni.showToast({
    title: msg,
    icon: "none",
  });
}
